module.exports = __webpack_public_path__ + "master-logo.53e1dff6.svg";